export const cleanText = (text: string) => text.split('\\n').join('\n\n')
